export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/wedding.c0a0c10.svg";